import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const htmlCssToImage = defineConnector({
  identifier: "htmlCssToImage",
  name: "HTML CSS to Image",
  tagLine: "HTML to image rendering API",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: (app) =>
    basicAuth({
      username: app.config.userId,
      password: app.secret.apiKey,
    }),
  steps: [
    {
      title: "Get your HTML/CSS to Image credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the HTML/CSS to Image dashboard, copy your User ID and API key. The API uses HTTP basic authentication.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "User ID",
          required: true,
          target: { kind: "configuration", field: "userId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://hcti.io/v1/image",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ html: "<div>3B</div>" }),
    }),
  },
  defaultUrlPattern: () => "https://hcti\\.io/.*",
});
